import type { LANGUAGES } from '@uefadigital/panenka';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useMatchUnitTranslations = () => {
  const [t, i18n] = useTranslation();
  const translations = useMemo(
    () => ({
      '1stleg': t('1_leg', '1st leg'),
      'line-ups': t('line_ups', 'Line-ups'),
      'single-leg-match': t('single_leg_match', 'Single-leg fixture'),
      abandoned: t('abandoned', 'Match abandoned'),
      aggregate_abbr: t('aggregate', 'Agg'),
      canceled: t('canceled', 'Match cancelled'),
      extra_time_short: t('extra_time_short', 'ET {minute}'),
      full_time: t('full_time', 'Full time'),
      ft: t('ft', 'FT'),
      live: t('live', 'Live'),
      owngoal_abbr: t('owngoal_abbr', 'og'),
      penalty_abbr: t('penalty_abbr', 'p'),
      postponed: t('postponed', 'Match postponed'),
      suspended: t('suspended', 'Match suspended'),
      futsal_foulcounter: t('futsal_foulcounter', 'Foul count'),
      tbc: t('tbc', 'TBC'),
    }),
    [t],
  );

  const dateCalendarFormat = useMemo(
    () => ({
      sameDay: `[${t('today', 'Today')}]`,
      nextDay: `[${t('tomorrow', 'Tomorrow')}]`,
      nextWeek: 'D MMM',
      lastDay: `[${t('yesterday', 'Yesterday')}]`,
      lastWeek: 'D MMM',
      sameElse: 'D MMM',
    }),
    [t],
  );

  const language = i18n.language.toUpperCase() as LANGUAGES;

  return { translations, dateCalendarFormat, language };
};
